import moment from 'moment';

import { Pipe, PipeTransform } from '@angular/core';

const enum MONTH {
  January = 0,
  February = 1,
  March = 2,
  April = 3,
  May = 4,
  June = 5,
  July = 6,
  August = 7,
  September = 8,
  October = 9,
  November = 10,
  December = 11,
}

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  transform(date: string, format: string = `YYYY-MM-DD HH:mm:ss`, currentFormat = ''): any {
    const month = moment(date, currentFormat).month();
    if (month !== MONTH.June && month !== MONTH.July) {
      format = format.replace('MMMM', 'MMM');
    }

    return moment(date, currentFormat).format(format);
  }
}
